$mol_view_tree2_to_js_test_ex_simple_default_indexed_foo $mol_object
	a_b*? 0
	legacy*k?v 0
